module.exports = __webpack_public_path__ + "img/slide-8-2.cfd4c285.jpg";